import Button from 'components/CustomButtons/Button';
import UserButton from 'components/CustomButtons/UserButton'
import moment from 'moment';
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import BackButton from 'components/BackButton'
import { apiRequest } from 'util/api/util'
import ReactTable from "react-table";
import EmailIcon from '@material-ui/icons/Email';
import ShareButton from 'components/ShareButton'
import ReactDOM from 'react-dom'
import {CSVDownload} from 'react-csv';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import {useLocation, useHistory} from 'util/router'
import Section from 'components/Section'
import LiveClassesSection from 'components/Challenges/LiveClassesSection'
import OnDemandSection from 'components/Challenges/OnDemandSection'
import PdfSection from 'components/Challenges/PdfSection'
import ChallengeSettingsSection from 'components/Challenges/ChallengeSettingsSection'

function PurchasesTable({isLoading, purchases}) {

    

    const data = purchases.map(val => {

        var nameConstructed = ""
        if (val?.user?.firstName) {
            nameConstructed = val.user.firstName
        }
        if (val?.user?.lastName) {
            nameConstructed = nameConstructed + " " + val.user.lastName
        }
        const pricingOption = val.pricingOption?.name ? val.pricingOption.name : (val?.offering?.name ? val.offering.name : "standard")
        const NOW = moment().unix()
        const ONEYEAR = moment().add(1,'y').unix()
        const expirationDate = moment(val.expires * 1000)
        return {
            purchaseId: val.id,
            userId: val.user.platformID,
            user: {
                name: val?.user?.firstName ?? nameConstructed,
                object: val.user ? (<UserButton user={val.user} />) : nameConstructed,
            },
            name: nameConstructed,
            email: val.user.email,
            created: val.created,
            datePurchased: moment(val.created * 1000).format("LLLL"),
            remaining: val?.offering?.type === "pack" ? val.remaining : "Unlimted",
            userId: val.user.platformID,
            // option: val.pricingOption?.name ? val.pricingOption.name : "standard",
            pricingOption: pricingOption,
            active: val.expires > NOW ? "true" : "false",
            canceled: val.canceled,
            realSubscription: val.chargeMetadata ? "true" : "false",
            nextPeriodStart: val.expires,
            nextPeriodStartDate: expirationDate.format('llll'),
            option: val?.offering?.type === 'subscription' ? (
                <>
                    <span>{pricingOption}</span><br></br>
                    { val.expires < ONEYEAR && (
                        <span>
                            {val.canceled ? `${val.expires > NOW ? "Expires" : "Expired"}` : "Renews"}&nbsp;{expirationDate.format("LLLL")}
                            
                        </span>
                    )}
                </>
                ) : (
                <>
                    <span>{pricingOption}</span><br></br>
                    {`${val.expires > NOW ? "Expires" : "Expired"} ${expirationDate.format("LL")}`}
                    {/* {val.canceled ? `${val.expires > NOW ? "Expires" : "Expired"}` : "Renews"}&nbsp;{expirationDate.format("LLLL")} */}
                </>
            ),
            id: (
                <div className="d-flex d-row align-items-center">
                    <input
                    style={{paddingRight: "50px"}}
                    type="text" value={val.user.platformID} readOnly={true} className={"form-control"}/>
                    <ShareButton link={val.user.platformID}
                    style={{marginLeft: "-50px"}}
                    />
                    
                </div>
            ),
            actions: (
                // we've added some custom button actions
                <div className="actions-right">
                  <Button
                    justIcon
                    round
                    simple
                    onClick={() => {
                      window.location.href = `mailto:${val.user.plat}`
                    }}
                    color="info"
                    className="like"
                  >
                    <EmailIcon />
                  </Button>{" "}
                </div>
              )
        }
    })

    function handleExport() {
        const headers = [
            {label: "userId", key: "userId"},
            {label: "purchaseId", key: "purchaseId"},
            {label: "pricingOption", key: "pricingOption"},
            {label: "active", key: "active"},
            {label: "canceled", key: "canceled"},
            {label: "realSubscription", key: "realSubscription"},
            {label: "nextPeriodStart", key: "nextPeriodStart"},
            {label: "nextPeriodStartDate", key: "nextPeriodStartDate"},
            {label: "Client Name", key: "name"},
            {label: "Client Email", key: "email"},
            {label: "Date Purchased", key: "datePurchased"},
        ]
        const element = (<CSVDownload filename={`export-purchases.csv`} data={data} headers={headers} target="_blank" />);
 
        ReactDOM.render(element, document.querySelector('#export-offerings-div'));
    }

    function handleEmailClass(e) {
        e.preventDefault()
        const emails = data.map(val => {
            return val.email
        })
        const mailTo = `mailto:?bcc=${emails.join(',')}`
        window.open(
            mailTo,
            '_blank' // <- This is what makes it open in a new window.
        );
        // window.location.href = 
    }

    return (
    <div>
        <div className="d-flex flex-row-reverse">
            <Button onClick={handleEmailClass} size={"lg"}>Email all students</Button>
            <Button onClick={handleExport} size={"sm"}>Export to CSV</Button>
            <div id='export-offerings-div'></div>
        </div>
        <ReactTable
        loading={isLoading}
                data={data}
                filterable
                columns={[
                    // {
                    // Header: "UserId",
                    // accessor: "userId"
                    // },
                    // {
                    // Header: "PurchaseId",
                    // accessor: "purchaseId"
                    // },
                    {
                    Header: "Name",
                    accessor: "user",
                    sort: 'desc',
                    sortMethod: (a,b) => {
                        // console.log(a.name)
                        // return a.name - b.name
                        if (a.name.length === b.name.length) {
                            return a.name > b.name ? 1 : -1;
                        }
                        return a.name.length > b.name.length ? 1 : -1;
                    },
                    Cell: row => (
                        <div>
                            {row.value.object}
                        </div>
                    ),
                    },
                    // {
                    // Header: "Name",
                    // accessor: "name",
                    // sort: 'desc'
                    // },
                    {
                    Header: "Email",
                    accessor: "email",
                    sort: 'desc'
                    },
                    {
                    Header: "Date Purchased",
                    accessor: "created",
                    sort: 'desc',
                    Cell: row => (
                        <div>
                            <h6>{moment(row.value * 1000).format("dddd MMM Do")}</h6>
                            <div>{moment(row.value * 1000).format("h:mm a")}</div>
                        </div>
                    ),
                    },
                    {
                    Header: "Pricing Option",
                    accessor: "option",
                    sort: 'desc',
                    },
                    {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                    }
                ]}
                defaultPageSize={10}
                showPaginationTop={false}
                showPaginationBottom={true}
                className="-highlight"
                  />
    </div>
    )
}

const titleFromKey = (key) => {
    const keys = {
        "students": "Student Roster",
        "live-classes": "Live Classes",
        "on-demand": "On Demand",
        "resources": "Resources",
        "settings": "Settings"
    }
    return keys[key] ?? "Settings"
}

function useTraceUpdate(props) {
    const prev = useRef(props);
    useEffect(() => {
      const changedProps = Object.entries(props).reduce((ps, [k, v]) => {
        if (prev.current[k] !== v) {
          ps[k] = [prev.current[k], v];
        }
        return ps;
      }, {});
      if (Object.keys(changedProps).length > 0) {
        console.log('Changed props:', changedProps);
      }
      prev.current = props;
    });
  }

function ChallengePurchases(props)  {

    const {challengeid} = props

    const [isLoading, setIsLoading] = React.useState(false)
    const [purchases, setPurchases] = React.useState([])

    // const selectedOffering = useSelector(state => state.instructor.offerings.find(val => val.id === challengeid))
        // .filter(val => val.id === challengeId))[0]

    useEffect(() => {
        setIsLoading(true)
        apiRequest(`app/dashboardPurchases?offeringId=${challengeid}`)
            .then(data => {
                const NOW = moment().unix()
                const filtered = data.filter(val => {
                    if (val?.offering?.type === 'subscription') {
                        return (val.expires ?? 0) > NOW
                    }
                    return true
                })
                setIsLoading(false)
                setPurchases(filtered)
            })
            .catch(err => {
                setIsLoading(false)
            })

    }, [])

    return (
        <PurchasesTable isLoading={isLoading} purchases={purchases} />
    )
}

function SingleChallengePage(props) {
    const offeringId = props.match.params.offeringId

    const selectedOffering = useSelector(state => state.instructor.offerings.find(val => val.id === offeringId))

    useTraceUpdate(props);

    const location = useLocation();
    const history = useHistory()
    const [key, setKey] = useState(location.hash ? location.hash.replace("#", "") : "live-classes");

    console.log("SCP - reRENDER")
    
    return (
        <div className="container">
            <BackButton />
            <div className="mt-2 mb-5">
                <h1 className="font-weight-bold">{selectedOffering?.name ?? ""}</h1>
            </div>
            { selectedOffering && (
                <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => {
                    history.push(location.pathname + `#${k}`)
                    setKey(k)
                }}
                >

                    <Tab eventKey="live-classes" title="Live Classes">
                        <Section>
                            <LiveClassesSection challengeid={offeringId} {...props} />
                        </Section>
                    </Tab>
                    <Tab eventKey="on-demand" title="On Demand Videos">
                        <Section>
                            <OnDemandSection challengeid={offeringId} {...props} />
                        </Section>
                    </Tab>
                    <Tab eventKey="resources" title="Resources">
                        <Section>
                            <PdfSection challengeid={offeringId} {...props} />
                        </Section>
                    </Tab>
                    <Tab eventKey="students" title="Student Roster">
                        <Section>
                            <ChallengePurchases challengeid={offeringId} {...props} />
                            {/* <PurchasesTable isLoading={isLoading} purchases={purchases} /> */}
                        </Section>
                    </Tab>
                    <Tab eventKey="settings" title="Settings">
                        <Section>
                            <ChallengeSettingsSection challengeid={offeringId} />
                            {/* // selectedOffering={selectedOffering} /> */}
                        </Section>
                    </Tab>
                </Tabs>
            
            )}
            
        </div>
    );
}

export default SingleChallengePage;
